
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const CourseTaxLawPage = lazy(() => import('../pages/course-tax-law/page'));
const KnowledgeMapPage = lazy(() => import('../pages/knowledge-map/page'));
const LearningPathsPage = lazy(() => import('../pages/learning-paths/page'));
const CompletedCoursesDetailPage = lazy(() => import('../pages/completed-courses-detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/courses',
    element: <CoursesPage />,
  },
  {
    path: '/course-tax-law',
    element: <CourseTaxLawPage />,
  },
  {
    path: '/knowledge-map',
    element: <KnowledgeMapPage />,
  },
  {
    path: '/learning-paths',
    element: <LearningPathsPage />,
  },
  {
    path: '/completed-courses-detail',
    element: <CompletedCoursesDetailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
